import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setIsTermsOpen(false);
  };

  console.log(drawerOpen, "drawerOpen");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRef = useRef(null);

  return (
    <>
      {/*===== PROGRESS STARTS=======*/}
      <div className="paginacontainer">
        <div className="progress-wrap">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          </svg>
        </div>
      </div>
      {/*===== PROGRESS ENDS=======*/}

      {/*=====HEADER START=======*/}
      <header className="homepage1-body">
        <div
          id="vl-header-sticky"
          className="vl-header-area vl-transparent-header"
        >
          <div className="container">
            <div className="row">
              {/* <div className="col-lg-12">
                <div className="header-top-area">
                  <div className="header-list">
                    <ul>
                      <li>
                        Welcome to our website - Explore Plans
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li>
                      <a href="mailto:support@kavatchhealthcare.com">
                        <svg className="translate-y-[2px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M2.92857 15.0714L7.57143 9.5M17.7857 15.0714L13.1429 9.5M2 5.78571L8.70893 10.2583C9.30461 10.6554 9.6024 10.854 9.92434 10.9311C10.2089 10.9994 10.5054 10.9994 10.7899 10.9311C11.1119 10.854 11.4097 10.6554 12.0054 10.2583L18.7143 5.78571M4.97143 16H15.7429C16.7829 16 17.303 16 17.7003 15.7976C18.0497 15.6196 18.3338 15.3354 18.5119 14.986C18.7143 14.5888 18.7143 14.0687 18.7143 13.0286V5.97143C18.7143 4.93134 18.7143 4.41128 18.5119 4.01402C18.3338 3.66457 18.0497 3.38046 17.7003 3.20252C17.303 3 16.7829 3 15.7429 3H4.97143C3.93134 3 3.41128 3 3.01402 3.20252C2.66457 3.38046 2.38046 3.66457 2.20252 4.01402C2 4.41128 2 4.93133 2 5.97143V13.0286C2 14.0687 2 14.5888 2.20252 14.986C2.38046 15.3354 2.66457 15.6196 3.01402 15.7976C3.41128 16 3.93133 16 4.97143 16Z"
                            stroke="#243A5E"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <div className="text-[16px]">support@kavatchhealthcare.com</div>
                      </a>
                    </li>
                    <li>
                      <a href="tel:919211977310">
                        <svg className="translate-y-[2px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M10.8763 5.83333C11.6903 5.99214 12.4383 6.39022 13.0247 6.97662C13.6111 7.56301 14.0092 8.31105 14.168 9.125M10.8763 2.5C12.5674 2.68787 14.1443 3.44514 15.3482 4.64751C16.5521 5.84987 17.3114 7.42584 17.5013 9.11667M14.5846 18.3333C7.45096 18.3333 1.66797 12.5503 1.66797 5.41667C1.66797 5.09482 1.67974 4.77572 1.70288 4.45977C1.72943 4.09718 1.7427 3.91589 1.83772 3.75086C1.91642 3.61417 2.05589 3.48455 2.19795 3.41604C2.36948 3.33333 2.56954 3.33333 2.96964 3.33333H5.3174C5.65387 3.33333 5.8221 3.33333 5.96632 3.38871C6.09371 3.43763 6.20714 3.51708 6.29665 3.62008C6.39798 3.73669 6.45547 3.8948 6.57046 4.21101L7.54222 6.88337C7.67597 7.25127 7.74289 7.43522 7.73155 7.60975C7.72155 7.76364 7.66897 7.91173 7.5798 8.03755C7.47869 8.18023 7.31084 8.28094 6.97516 8.48235L5.83464 9.16667C6.83622 11.3741 8.62638 13.1666 10.8346 14.1667L11.519 13.0262C11.7204 12.6904 11.8211 12.5226 11.9637 12.4215C12.0896 12.3323 12.2376 12.2797 12.3916 12.2697C12.5661 12.2584 12.7501 12.3253 13.118 12.4591L15.7903 13.4308C16.1065 13.5458 16.2646 13.6033 16.3812 13.7047C16.4842 13.7942 16.5637 13.9076 16.6126 14.035C16.668 14.1792 16.668 14.3474 16.668 14.6839V17.0317C16.668 17.4317 16.668 17.6318 16.5852 17.8033C16.5167 17.9454 16.3871 18.0849 16.2505 18.1636C16.0854 18.2586 15.9041 18.2718 15.5416 18.2984C15.2256 18.3216 14.9065 18.3333 14.5846 18.3333Z"
                            stroke="#243A5E"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <div className="text-[16px]">18002681155</div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
              {/* <div className="space16 d-lg-block d-none" /> */}
            </div>
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-6 col-6">
                <div className="vl-logo">
                  <Link to="/">
                    <img src="assets/img/logo/brand_logo.png" alt="" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-5 d-none d-lg-block">
                <div className="vl-main-menu text-center">
                  <nav className="vl-mobile-menu-active">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/plans">Plans</Link>
                      </li>
                      <li className="has-dropdown">
                        <Link>
                          Terms & Policies
                          <span className="arrow-size ml-2">
                            <i className="fa-solid fa-angle-down d-lg-inline d-none" />
                          </span>
                        </Link>
                        <ul className="sub-menu">
                          <li>
                            <Link to="/term-of-use">Terms Of Use</Link>
                          </li>
                          <li>
                            <Link to="/shipping-delivery-policy">
                              Shipping & Delivery Policy
                            </Link>
                          </li>
                          <li>
                            <Link to="/cancellation-policy">
                              Cancellation Policy
                            </Link>
                          </li>
                          <li>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-6">
                <div className="vl-hero-btn d-none d-lg-block text-end">
                  <a href="/login.html" target="_blank" className="vl-btn6">
                    Login App
                  </a>
                </div>
                <div className="vl-header-action-item d-block d-lg-none">
                  <button
                    type="button"
                    onClick={() => {
                      setDrawerOpen(!drawerOpen);
                    }}
                    className="vl-offcanvas-toggle"
                  >
                    <i className="fa-solid fa-bars-staggered" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="space8 d-lg-block d-none" />
      {/*=====HEADER END =======*/}
      {/*===== MOBILE HEADER STARTS =======*/}
      <div className="homepage1-body">
        {drawerOpen && (
          <div className="vl-offcanvas vl-offcanvas-open">
            <div className="vl-offcanvas-wrapper">
              <div className="vl-offcanvas-header d-flex justify-content-between align-items-center mb-0">
                <div className="vl-offcanvas-logo"></div>
                <div className="vl-offcanvas-close">
                  <button
                    className="vl-offcanvas-close-toggle"
                    onClick={handleCloseDrawer}
                  >
                    <i className="fa-solid fa-xmark" />
                  </button>
                </div>
              </div>
              <div className="vl-offcanvas-menu d-lg-none mb-40">
                <nav className="vl-mobile-menu-active">
                  <ul>
                    <li>
                      <Link to="/" onClick={handleCloseDrawer}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/plans" onClick={handleCloseDrawer}>
                        Plans
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="!flex w-full justify-between items-center gap-2"
                        onClick={() => setIsTermsOpen(!isTermsOpen)}
                      >
                        Terms & Policies
                        <span className="arrow-size ml-2">
                          <i
                            className={`fa-solid fa-angle-down text-white ${
                              isTermsOpen
                                ? "rotate-180 transition-all"
                                : "transition-all"
                            }`}
                          />
                        </span>
                      </Link>
                      {isTermsOpen && (
                        <ul className="bg-[#2c4670] px-4 py-2 my-2 rounded-lg">
                          <li>
                            <Link to="/term-of-use" onClick={handleCloseDrawer}>
                              Terms Of Use
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/shipping-delivery-policy"
                              onClick={handleCloseDrawer}
                            >
                              Shipping & Delivery Policy
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/cancellation-policy"
                              onClick={handleCloseDrawer}
                            >
                              Cancellation Policy
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/privacy-policy"
                              onClick={handleCloseDrawer}
                            >
                              Privacy Policy
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>

                    <li>
                      <Link to="/contact" onClick={handleCloseDrawer}>
                        Contact Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/login.html" target="_blank"  className="bg-[#ffffff] !text-[#243A5E] w-fit px-4 mt-2 rounded-full" onClick={handleCloseDrawer}>
                        Login
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="space20" />
              <div className="vl-offcanvas-info">
                <h3 className="vl-offcanvas-sm-title">Contact Us</h3>
                <div className="space20" />
                <span>
                  <a href="tel:18002681155">
                    <i className="fa-regular fa-envelope" /> 18002681155
                  </a>
                </span>
                <span>
                  <a href="mailto:support@kavatchhealthcare.com">
                    <i className="fa-solid fa-phone" />
                    support@kavatchhealthcare.com
                  </a>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      {/*===== MOBILE HEADER STARTS =======*/}
    </>
  );
};

export default Header;
